 export const HEADER_NAV = 'HEADER';
 export const FOOTER_NAV = 'FOOTER';
 export const INSURANCE_NAV = 'INSURANCE';
 export const PREPAID_NAV = 'PREPAID';
 export const DEBIT_NAV = 'DEBIT';
 export const HOME_NAV = 'HOME';
 export const HEADER_MOBILE_CTAS = 'HEADER_MOBILE_CTAS';
